import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface ISelected {
  id?: number;
  location?: string;
  name?: string;
  state_id?: number;
}

export interface ISelectedLocation {
  selectedLocation: ISelected;
}

const initialState: ISelected = {};

export const selectedLocationSlice = createSlice({
  name: 'myStoreSelectedLocation',
  initialState,
  reducers: {
    addAddress: (state, action: PayloadAction<ISelected>) => {
      state.id = action.payload.id;
      state.location = action.payload.location;
      state.name = action.payload.name;
      state.state_id = action.payload.state_id;
    },
    clearAddress: state => {
      state = {} as ISelected;
    },
  },
});

export const {addAddress, clearAddress} = selectedLocationSlice.actions;

export default selectedLocationSlice.reducer;
